import { get, put } from "./api"

export const getOnboardingSteps = () => {
  return get("/onboarding-org/my")
}

export const updateOnboardingSteps = (params) => {
  return put("/onboarding-org/my", params)
}
